import { buildApiUrl, withBusinessHeaders } from './apiConfig';

const STAFF_DASHBOARD_API_URL =
  process.env.REACT_APP_STAFF_DASHBOARD_API_URL ||
  buildApiUrl('/staff/dashboard');

export async function fetchStaffDashboard() {
  const response = await requestStaffDashboardApi(STAFF_DASHBOARD_API_URL, {
    fallbackMessage: 'Unable to load the staff dashboard right now.',
  });

  return response.json();
}

async function requestStaffDashboardApi(url, options) {
  const { fallbackMessage, ...requestOptions } = options;
  let response;

  try {
    response = await fetch(url, {
      ...requestOptions,
      headers: withBusinessHeaders(requestOptions.headers),
    });
  } catch (error) {
    throw new Error(getNetworkErrorMessage(error, fallbackMessage));
  }

  if (!response.ok) {
    const errorPayload = await safeReadJson(response);
    throw new Error(errorPayload?.message || fallbackMessage);
  }

  return response;
}

function getNetworkErrorMessage(error, fallbackMessage) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'You are offline right now. Please reconnect to continue.';
  }

  if (error instanceof TypeError) {
    return 'Unable to reach the server right now. Please check your connection or try again in a moment.';
  }

  return fallbackMessage;
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
